<template>
<ion-input
    type="text"
    readonly="true"
    :value="value.value"></ion-input>
</template>

<script>
import Field from "../models/Field";
import Value from "../models/Value";
export default {
  name: "field-readonly",
  components: {},
  props: ["field", "value"],
}
</script>

<style scoped>

</style>